import React from 'react';

import MarketoForm from '../components/marketo-form/marketo-form';
import PardotFormHandler from '../components/pardot-form/pardot-form';
import HubSpotForm from '../components/hubspot-form/hubspot-form';

import contactValues from '../static-content/contact.json';

export const switchContactForm = (customForm, geoSpace, setFormComplete, requireForm, slug, submissionText, hiddenFieldText) => {
  const formType = customForm?.formType?.toUpperCase();
  let contactForm;

  if (!customForm && geoSpace == 'en-us') {
    contactForm = <MarketoForm formId={'1017'} setFormComplete={setFormComplete} submissionText={submissionText} />;
  } else {
    switch (formType) {
      case contactValues.MARKETO_FORM:
        contactForm = (
          <MarketoForm formId={customForm?.formId} setFormComplete={setFormComplete} submissionText={customForm?.formBody?.formBody || submissionText} />
        );
        break;
      case contactValues.PARDOT_BASIC_FORM:
      case contactValues.PARDOT_STANDARD_FORM:
      case contactValues.PARDOT_TOF_FORM:
      case contactValues.PARDOT_MOF_FORM:
      case contactValues.PARDOT_BOF_FORM:
      case contactValues.PARDOT_FAST_TRACK_FORM:
      case contactValues.PARDOT_AI_MATURITY_ASSESSMENT:
        contactForm = (
          <PardotFormHandler formType={formType} actionURL={customForm?.formId} setFormComplete={setFormComplete} geoSpace={geoSpace}/>
        );
        break;
      default:
        contactForm = (
          <HubSpotForm
            geoSpace={geoSpace}
            slug={slug || customForm?.slug || 'contact'}
            isGatedContentForm={requireForm}
            hiddenFieldText={hiddenFieldText}
            onSubmit={() => {
              setFormComplete(true);
            }}
          />
        );
        break;
    }
  }

  return contactForm;
};
